export const calculatorsData = [
  {
    id: 1,
    calculatorName: "Personal Loan Eligibility Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-loan-eligibility-1738408950424.webp",
    link: "/calculators/eligibility-calculators/personal-loan-eligibility-calculator",
  },
  {
    id: 2,
    calculatorName: "Car Loan Eligibility Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/car-loan-eligibility-1738406086555.webp",
    link: "/calculators/eligibility-calculators/car-loan-eligibility-calculator",
  },
  {
    id: 3,
    calculatorName: "Home Loan Eligibility Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/home-loan-eligibility-1738835920818.webp",
    link: "/calculators/eligibility-calculators/home-loan-eligibility-calculator",
  },
];
